import { all, call, fork, put, takeEvery } from 'redux-saga/effects';


// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
import moment from 'moment';

import {
  MESSAGES_OUTBOX_TAB_LOAD_DATA
} from 'Redux/actionTypes';

import {
  messagesOutboxTabGetDataResult,
} from 'Redux/actions';

function* getMessagesOutboxTabDataAsync({ payload }) {
  try {

    const { deviceId, filters, nextToken } = payload;


    let MESSAGES_OUTBOX = ""
    let data = { getEventData: [] }
    let queryParams = {}
    let result = [];
    let nxtToken = null;
    let dateFrom = null;
    let dateTo = null;
    let dateRange = null

    MESSAGES_OUTBOX = `
        query searchMessageOutbox ($searchBy: enumMessageOutboxSearchBy!, $entityName: enumEntityName, $entityId: String, $dateRange: AWSDateTimeRange, $limit: Int, $nextToken: String, $lastRecords: Int) {
          result: searchMessageOutbox (searchBy: $searchBy, entityName: $entityName, entityId: $entityId, dateRange: $dateRange, limit: $limit, nextToken: $nextToken, lastRecords: $lastRecords) {
              items {
                to
                via
                message
                description
                status
                createdOn
                createdBy
              }
              nextToken
            }
        }    
        `;


    if (filters.type !== 'last') {

      dateFrom = moment(filters.startDate).format("YYYY-MM-DD") + "T00:00:00-04:00";
      dateTo = moment(filters.endDate).format("YYYY-MM-DD") + "T23:59:59-04:00";
      dateRange = { start: dateFrom, end: dateTo }
    }

    queryParams = {
      searchBy: "TargetEntityNameId",
      entityName: "Unit",
      entityId: `${deviceId}`,
      //dateRange: dateRange,
      limit: filters.limit,
      nextToken: nextToken
    }

    if(filters.type === 'last'){
      queryParams.lastRecords = filters.last.id
    }else{
      queryParams.dateRange = dateRange
    }

    data = yield call(
      clientQuery,
      MESSAGES_OUTBOX,
      queryParams,
      endpoints.GRAPHQL_GENERAL
    );

    if (data?.result?.items?.length > 0 && data?.result?.items !== "[]") {
      result = data?.result?.items;
      nxtToken = data?.result?.nextToken;
    }

    yield put(messagesOutboxTabGetDataResult({ items: result, nextToken: nxtToken, oldNextToken: nextToken, conditions: queryParams }));

  } catch (exc) {

    yield put(messagesOutboxTabGetDataResult({ error: exc }));
    ExceptionManager(exc, "modules/devices/.components/messagesOutboxTab/redux/saga/", "getMessagesOutboxTabDataAsync", true)
  }
}

function* watchMethods() {
  yield takeEvery(MESSAGES_OUTBOX_TAB_LOAD_DATA, getMessagesOutboxTabDataAsync);
}

export default function* rootSaga() {
  yield all([fork(watchMethods)]);
}